import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilsService} from '../_services/utils.service';
import {resolveLandingPath} from '../_helpers/role-landing';

@Component({
  selector: 'app-hub-login',
  template: '<div class="container p-4"><h3>Opening secure support session…</h3><p *ngIf="error">{{error}}</p></div>'
})
export class HubLoginComponent implements OnInit {
  error = '';

  constructor(private http: HttpClient, private utils: UtilsService) {}

  ngOnInit(): void {
    const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const handoff = fragment.get('handoff');
    history.replaceState(null, document.title, window.location.pathname);
    if (!handoff) {
      this.error = 'This secure login link is invalid.';
      return;
    }
    this.http.post<any>('/superadmin/login-tickets/session', {handoff}).subscribe({
      next: response => {
        const user = response && response.user;
        if (!user || !user.token) {
          this.error = 'The product returned an invalid support session.';
          return;
        }
        // Normalize role to an array. redeemLoginHandoff / publicUserShape may
        // return role as a single string OR an array, and `string.length > 1`
        // would misfire (any 2+ char role string looked "multi-role").
        const roles = Array.isArray(user.role) ? user.role : (user.role != null ? [user.role] : []);
        const role = roles[0];
        this.utils.setCurrentUser(user, role);

        // Resolve the landing destination, then map it to a URL that actually
        // resolves in the router. THIS is the real "secret login lands on the
        // home page" bug: the previous targets were unreachable routes that
        // fell through the app '**' wildcard (-> cloverAuth/cloverAuth = home).
        //   - '/select-role' has NO top-level route: RoleSelectComponent is a
        //     child of the lazy LoginModule (mounted at 'login'), so its real
        //     URL is '/login/select-role'. A bare '/select-role' never matches.
        //   - resolveLandingPath() returns '/login' for any role not in
        //     DEFAULT_LANDING_BY_ROLE; '/login' has no empty-path child and
        //     also dead-ends at the wildcard.
        // Mapped single roles (Admin -> /sidebar/cashier, Kiosk -> /kiosk, etc.)
        // already resolve to valid top-level routes and are left untouched.
        const resolved = roles.length > 1
          ? '/login/select-role'
          : resolveLandingPath(role, user.preferences && user.preferences.defaultLandingPath);
        // Guarantee an authenticated, role-agnostic destination for any role we
        // could not map, instead of bouncing the operator back to the login/home.
        const target = (!resolved || resolved === '/login') ? '/login/select-role' : resolved;

        // Full-document navigation (matches the reload the normal Admin login
        // performs) so the app re-bootstraps and AuthGuard reads the freshly
        // stored localStorage session on the guarded landing route.
        window.location.assign(target);
      },
      error: () => this.error = 'This secure login link expired or was already used.'
    });
  }
}
